import { useAppSelector } from "../store/configureStore";
import { useLocation } from "react-router-dom";
import { ORDERSTATUS } from "../models/order";
import useReadOnlyPreset from "./useReadOnlyPreset";
import useHQmanager from "./useHQmanager";

// Bulk actions (row selection + ship / picklists).
// - HQ only needs them on the Approve preset; everywhere else the table stays
//   server-side paginated without bulk.
// - Picker / admin get them on the flow presets (Approve / Manage / Send) and,
//   on the manual Backorder path, once the list is narrowed to a status AND a
//   promo code (lists are requested per promo). Never on read-only Original/All.
export default function useBulkActionsAvailable(): boolean {
  const { search } = useLocation();
  const preset = new URLSearchParams(search).get("preset");
  const { order_status, promo_code } = useAppSelector(
    (state) => state.orders.order_params,
  );
  const { user } = useAppSelector((state) => state.account);
  const isHQ = useHQmanager(user);
  const readOnly = useReadOnlyPreset();

  if (isHQ) return preset === "approve";

  const hasStatusFilter =
    typeof order_status === "string" && order_status !== "";
  // Cancelled is terminal — no bulk action applies, so no selection column.
  const isCancelled = order_status === ORDERSTATUS.cancelled;

  // Flow presets keep selection without a promo, once narrowed to their status
  // (approve / set in progress / ship).
  const isFlowPreset =
    preset === "approve" || preset === "handle" || preset === "send";
  if (isFlowPreset) return hasStatusFilter && !isCancelled && !readOnly;

  // Backorder path: selecting to request lists needs a promo code; a status
  // filter is optional (just not Cancelled / read-only Original).
  const hasPromoCode = typeof promo_code === "string" && promo_code !== "";
  return hasPromoCode && !isCancelled && !readOnly;
}
